'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  padding: 24px 64px;\n  border-radius: 3px;\n  background-color: #ffffff;\n  box-shadow: 0 2px 4px 0 rgba(153,153,153,0.2);\n  ', '\n'], ['\n  padding: 24px 64px;\n  border-radius: 3px;\n  background-color: #ffffff;\n  box-shadow: 0 2px 4px 0 rgba(153,153,153,0.2);\n  ', '\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['padding: 8px 16px 24px 16px;'], ['padding: 8px 16px 24px 16px;']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _medias = require('../../../util/medias');

var _medias2 = _interopRequireDefault(_medias);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Paper = _styledComponents2.default.div(_templateObject, _medias2.default.small(_templateObject2));

exports.default = Paper;